<template>
  <vue-plyr ref="plyr" :options="options">
    <video controls crossorigin playsinline>
      <source :src="src.url" :type="src.mime" />
    </video>
  </vue-plyr>
</template>

<script>
export default {
  props: {
    isInViewport: {
      type: Boolean,
      default() {
        return false
      },
    },
    options: {
      type: Object,
      default() {
        return {
          loop: {
            active: true
          }
        }
      },
    },
    src: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.player = this.$refs.plyr.player
  },
  watch: {
    isInViewport(newVal) {
      if(newVal && this.player) {
        this.player.play()
      } else {
        this.player.pause()
      }
    }
  }
}
</script>